import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
const IcoJcb16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <g><path d="M16 11.8386C16 13.2078 14.8851 14.3227 13.5159 14.3227H0V4.48411C0 3.11491 1.11491 2 2.48411 2H16V11.8386Z" fill="#fff" /><path d="M12.5085 2.83133C11.5305 2.83133 10.7285 3.62351 10.7285 4.61128V6.45969H13.242C13.3007 6.45969 13.3691 6.45969 13.418 6.46947C13.9853 6.49881 14.4058 6.79221 14.4058 7.30077C14.4058 7.70174 14.1222 8.04404 13.5941 8.1125V8.13206C14.1711 8.17118 14.6112 8.49392 14.6112 8.9927C14.6112 9.53059 14.1222 9.88267 13.4767 9.88267H10.7188V13.5013H13.33C14.308 13.5013 15.1099 12.7091 15.1099 11.7213V2.83133H12.5085Z" fill="url(#b)" /><path d="M11.5989 9.31543H12.6258C12.6405 9.31543 12.665 9.31298 12.6894 9.31054C12.7139 9.30809 12.7383 9.30565 12.753 9.30565C12.9486 9.26653 13.1148 9.09049 13.1148 8.84599C13.1148 8.61127 12.9486 8.43523 12.753 8.38633C12.7236 8.37655 12.665 8.37655 12.6258 8.37655H11.5989V9.31543Z" fill="url(#c)" /><path d="M12.6258 6.99758C12.8214 7.02692 12.9877 7.1834 12.9877 7.41812C12.9877 7.65284 12.8214 7.80932 12.6258 7.83866C12.6161 7.84844 12.5574 7.84844 12.528 7.84844H11.5989V6.9878H12.528C12.5442 6.9878 12.5663 6.99077 12.5861 6.99343C12.6023 6.99561 12.617 6.99758 12.6258 6.99758Z" fill="url(#d)" /><path d="M2.6701 2.83133C1.69211 2.83133 0.890151 3.62351 0.890151 4.61128V9.00248C1.38893 9.24698 1.90727 9.40346 2.4256 9.40346C3.04174 9.40346 3.37426 9.03182 3.37426 8.52326V6.44991H4.89993V8.51348C4.89993 9.31544 4.40115 9.97069 2.70922 9.97069C1.68233 9.97069 0.880371 9.74575 0.880371 9.74575V13.4915H3.49162C4.46961 13.4915 5.27157 12.6993 5.27157 11.7115V2.83133H2.6701Z" fill="url(#e)" /><path d="M7.58903 2.83133C6.61104 2.83133 5.80908 3.62351 5.80908 4.61128V6.93891C6.25896 6.55749 7.04136 6.31299 8.30297 6.37167C8.97779 6.40101 9.7015 6.58683 9.7015 6.58683V7.33989C9.33964 7.15407 8.90933 6.98781 8.35187 6.94869C7.39343 6.88023 6.81642 7.34967 6.81642 8.17118C6.81642 9.00248 7.39343 9.47192 8.35187 9.39368C8.90933 9.35456 9.33964 9.17852 9.7015 9.00248V9.75553C9.7015 9.75553 8.98757 9.94135 8.30297 9.97069C7.04136 10.0294 6.25896 9.78487 5.80908 9.40346V13.511H8.42033C9.39832 13.511 10.2003 12.7189 10.2003 11.7311V2.83133H7.58903Z" fill="url(#f)" /></g>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <linearGradient id="b" x1={10.727} y1={7.417} x2={15.122} y2={7.417} gradientUnits="userSpaceOnUse"><stop stopColor="#007940" /><stop offset={0.229} stopColor="#00873F" /><stop offset={0.743} stopColor="#40A737" /><stop offset={1} stopColor="#5CB531" /></linearGradient>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <linearGradient id="c" x1={10.727} y1={7.417} x2={15.122} y2={7.417} gradientUnits="userSpaceOnUse"><stop stopColor="#007940" /><stop offset={0.229} stopColor="#00873F" /><stop offset={0.743} stopColor="#40A737" /><stop offset={1} stopColor="#5CB531" /></linearGradient>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <linearGradient id="d" x1={10.727} y1={7.417} x2={15.122} y2={7.417} gradientUnits="userSpaceOnUse"><stop stopColor="#007940" /><stop offset={0.229} stopColor="#00873F" /><stop offset={0.743} stopColor="#40A737" /><stop offset={1} stopColor="#5CB531" /></linearGradient>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <linearGradient id="e" x1={0.888} y1={8.162} x2={5.351} y2={8.162} gradientUnits="userSpaceOnUse"><stop stopColor="#1F286F" /><stop offset={0.475} stopColor="#004E94" /><stop offset={0.826} stopColor="#0066B1" /><stop offset={1} stopColor="#006FBC" /></linearGradient>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <defs>{t2}{t3}{t4}{t5}<linearGradient id="f" x1={5.784} y1={8.162} x2={10.118} y2={8.162} gradientUnits="userSpaceOnUse"><stop stopColor="#6C2C2F" /><stop offset={0.173} stopColor="#882730" /><stop offset={0.573} stopColor="#BE1833" /><stop offset={0.859} stopColor="#DC0436" /><stop offset={1} stopColor="#E60039" /></linearGradient></defs>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== ariaLabel || $[7] !== className) {
    t7 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={true}>{t1}{t6}</svg>;
    $[6] = ariaLabel;
    $[7] = className;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default IcoJcb16;